/*
  Compact number text — 1000 -> 1K, 1500 -> 1.5K, 100000 -> 100K, 2500000 -> 2.5M.

  A PORT of mobile's `formatCompactNumber` (`src/utils/commonUtils.ts`), symbols and one-decimal
  rule included, so a points pill reads identically on both surfaces. Kept beside
  `getNumberFormat` rather than folded into it: that one groups thousands for counts read at
  leisure (1,234 followers), this one shortens a number that has to fit inside a pill.

  Unlike mobile's, this coerces first. Mobile is fed numbers it owns; the web is fed wire data,
  and `undefined.toString()` would take the whole header down over a missing field.
*/
function formatCompactNumber(num) {
  const value = Number(num);
  if (isNaN(value)) return '0';

  const units = [
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' }
  ];

  // Sign handled separately so the units below only ever see a magnitude — otherwise -1500
  // compares against the thresholds as a negative and falls through to "-1500".
  const sign = value < 0 ? '-' : '';
  const abs = Math.abs(value);

  for (const unit of units) {
    if (abs >= unit.value) {
      const scaled = abs / unit.value;
      // A whole number keeps no decimal: "1K", not "1.0K".
      return `${sign}${scaled % 1 === 0 ? scaled : scaled.toFixed(1)}${unit.symbol}`;
    }
  }

  return `${sign}${abs}`;
}

export default formatCompactNumber;
